import React from 'react'
import { FilterInput } from '@typings/graphql'
import { useLocation, useParams } from 'react-router'
import { GridFilterModel } from '@mui/x-data-grid-pro'

import { getFilterString } from '../utils/filter'

export type UseFilterParameter = {
  parseToFilter: () => GridFilterModel | null
  parseToParam: (filter: FilterInput[]) => string
}

export const useFilterParameter = () => {
  const { search } = useLocation()
  const { filter: filterParam } = useParams<{ filter: string }>()

  const parseToFilter = React.useCallback<() => GridFilterModel | null>(() => {
    if (!filterParam || !search) {
      return null
    }

    try {
      const decodedFilter = JSON.parse(decodeURIComponent(search.replace('?', ''))) as FilterInput[]

      return {
        items: decodedFilter.map<GridFilterModel['items'][0]>((f) => {
          return {
            id: Math.random().toString(),
            field: f.field,
            value: f.value,
            operator: getFilterString(f.operator, f.type)
          }
        })
      }
    } catch (e) {
      return {
        items: []
      }
    }
  }, [search, filterParam])

  const parseToParam = React.useCallback((filterInput: FilterInput[]) => {
    const stringifiedHash = JSON.stringify(filterInput)

    return `filter?${encodeURIComponent(stringifiedHash)}`
  }, [])

  return {
    parseToFilter,
    parseToParam
  }
}
